// Libraries
var React = require('react');

// Styles
require('./Stats.scss');

class MidfielderStats extends React.Component {
    render() {
        return (
            <div className="Stats">
                {!isNaN(this.props.minutesPlayed) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.minutesPlayed}</p>
                        <p className="Stats__item--heading">Minutes Played</p>
                    </div>
                }

                {!isNaN(this.props.goalsScored) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.goalsScored}</p>
                        <p className="Stats__item--heading">Goals Scored</p>
                    </div>
                }

                {!isNaN(this.props.assists) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.assists}</p>
                        <p className="Stats__item--heading">Assists</p>
                    </div>
                }

                {!isNaN(this.props.totalPasses) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.totalPasses}</p>
                        <p className="Stats__item--heading">Total Passes</p>
                    </div>
                }

                {!isNaN(this.props.completedPasses) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.completedPasses}</p>
                        <p className="Stats__item--heading">Completed Passes</p>
                    </div>
                }

                {!isNaN(this.props.touches) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.touches}</p>
                        <p className="Stats__item--heading">Touches</p>
                    </div>
                }

                {!isNaN(this.props.passAccuracy) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.passAccuracy}%</p>
                        <p className="Stats__item--heading">Pass Accuracy</p>
                    </div>
                }

                {!isNaN(this.props.yellowCards) && !isNaN(this.props.redCards) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value"><span className="yellowcard" aria-label="Number of yellow cards">{this.props.yellowCards}</span> <span className="redcard" aria-label="Number of red cards">{this.props.redCards}</span></p>
                        <p className="Stats__item--heading">Cards</p>
                    </div>
                }
            </div>
        )
    }
}

module.exports = MidfielderStats;



// WEBPACK FOOTER //
// ./src/components/LastFixturePlayerStats/MidfielderStats.js